import {
	isResultsPersonaId,
	RESULTS_PERSONA_IDS,
	type ResultsPersonaId,
} from "@narrator/personaIds";

/** localStorage key for consumer SPA character / persona dialect preference. */
export const WI_PERSONA_KEY = "wi-persona";

export { RESULTS_PERSONA_IDS, isResultsPersonaId };
export type { ResultsPersonaId };

/** Pure resolver for tests — query wins, then stored, then legacy ?tone=casual → witty. */
export function resolvePersonaPreference(
	queryPersona: string | null,
	storedPersona: string | null,
	queryTone: string | null = null,
): ResultsPersonaId {
	if (queryPersona && isResultsPersonaId(queryPersona)) return queryPersona;
	if (storedPersona && isResultsPersonaId(storedPersona)) return storedPersona;
	if (queryTone === "casual") return "witty";
	return "neutral";
}

export function readStoredPersona(): ResultsPersonaId {
	if (typeof window === "undefined") return "neutral";
	try {
		const raw = window.localStorage.getItem(WI_PERSONA_KEY);
		if (raw && isResultsPersonaId(raw)) return raw;
	} catch {
		/* private mode */
	}
	return "neutral";
}

export function getPersonaPreference(): ResultsPersonaId {
	if (typeof window === "undefined") return "neutral";
	const params = new URLSearchParams(window.location.search);
	return resolvePersonaPreference(
		params.get("persona"),
		window.localStorage.getItem(WI_PERSONA_KEY),
		params.get("tone"),
	);
}

export function setPersonaPreference(personaId: ResultsPersonaId): void {
	if (typeof window === "undefined") return;
	try {
		window.localStorage.setItem(WI_PERSONA_KEY, personaId);
	} catch {
		/* ignore */
	}
}

/** Voter invite path; non-neutral personas append `?persona=` for shareable dialect. */
export function voterPathWithPersona(roomId: string, personaId: ResultsPersonaId): string {
	const base = `/r/${encodeURIComponent(roomId)}`;
	return personaId === "neutral" ? base : `${base}?persona=${encodeURIComponent(personaId)}`;
}
